import { SCREEN_WIDTH, fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { StyleSheet, View } from "react-native";
import Svg, { Path } from "react-native-svg";
import { router, useGlobalSearchParams } from "expo-router";

import { Colors } from "colors";
import ImageView from "../../../src/image";

import React from "react";
import { TouchableOpacity } from "react-native";
import VText from "components/VText";

const ShoppablePageItem = ({ item, _shoppableRef }) => {
    const local = useGlobalSearchParams();
    const gender = local?.gender ?? "female";

    const EditItem = ({ title, thumbnailUrl, thumbnailWebUrl, index, description, id }) => (
        <View
            style={[
                {
                    width: [0, 9].includes(index)
                        ? SCREEN_WIDTH
                        : [3, 4, 5, 6, 7, 8, 12, 13, 14].includes(index) || index > 14
                        ? wp(403)
                        : wp(612),
                },
            ]}
        >
            <TouchableOpacity
                onPress={() => {
                    _shoppableRef?.current?.show(id);
                }}
            >
                <ImageView
                    source={{ uri: [0, 9].includes(index) ? thumbnailWebUrl : thumbnailUrl }}
                    style={{
                        height: [0, 9].includes(index)
                            ? SCREEN_WIDTH / 2.4
                            : [3, 4, 5, 6, 7, 8, 12, 13, 14].includes(index) || index > 14
                            ? wp(537)
                            : wp(816),
                        width: [0, 9].includes(index)
                            ? SCREEN_WIDTH
                            : [3, 4, 5, 6, 7, 8, 12, 13, 14].includes(index) || index > 14
                            ? wp(403)
                            : wp(612),
                    }}
                    resizeMode={ImageView.resizeMode.cover}
                />
                <View
                    style={{
                        position: "absolute",
                        top: [0, 9].includes(index)
                            ? SCREEN_WIDTH / 2.4 / 2 - 40
                            : [3, 4, 5, 6, 7, 8, 12, 13, 14].includes(index) || index > 14
                            ? wp(228.5)
                            : wp(368),
                        left: [0, 9].includes(index)
                            ? SCREEN_WIDTH / 2 - 40
                            : [3, 4, 5, 6, 7, 8, 12, 13, 14].includes(index) || index > 14
                            ? wp(161.5)
                            : wp(266),
                    }}
                >
                    <Svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <Path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0 40C0 17.92 17.92 0 40 0C62.08 0 80 17.92 80 40C80 62.08 62.08 80 40 80C17.92 80 0 62.08 0 40ZM35.3848 24.4069C33.9885 23.4074 32 24.3669 32 26.0062V53.9938C32 55.6331 33.9885 56.5926 35.3848 55.5931L55.1432 41.5993C56.2856 40.7996 56.2856 39.2004 55.1432 38.4007L35.3848 24.4069Z"
                            fill="white"
                        />
                    </Svg>
                </View>
            </TouchableOpacity>
            <View
                style={{
                    paddingTop: spV(20),
                }}
            >
                <VText
                    numberOfLines={1}
                    style={[styles.itemTitle, { color: [3, 4, 5].includes(index) || index > 14 ? "white" : "#212427" }]}
                >
                    {title}
                </VText>
                {description && (
                    <VText
                        numberOfLines={2}
                        style={[
                            styles.subTitle,
                            {
                                color: [3, 4, 5].includes(index) || index > 14 ? "white" : "#212427",
                                width: "100%",
                                paddingHorizontal: 20,
                            },
                        ]}
                    >
                        {`${description}`}
                    </VText>
                )}
            </View>
        </View>
    );

    if (item?.length == 0) {
        return (
            <View>
                <VText
                    style={{
                        textAlign: "center",
                        paddingTop: hp(200),
                        fontSize: fp(24),
                    }}
                    text={"No Videos Found"}
                />
            </View>
        );
    }

    return (
        <View style={styles.listViewContainer}>
            <View>
                {item?.[0] && <EditItem gender={gender} router={router} index={0} {...item?.[0]} />}
                {item?.[1] && (
                    <View
                        style={{
                            flexDirection: "row",
                            width: "100%",
                            paddingHorizontal: wp(93.5),
                            marginTop: spV(48),
                            marginBottom: spV(28),
                        }}
                    >
                        <View
                            style={{
                                marginRight: spH(31),
                            }}
                        >
                            {item?.[1] && <EditItem gender={gender} router={router} index={1} {...item?.[1]} />}
                        </View>
                        {item?.[2] && <EditItem gender={gender} router={router} index={2} {...item?.[2]} />}
                    </View>
                )}
                {item?.[3] && (
                    <View
                        style={{
                            flexDirection: "row",
                            width: "100%",
                            paddingHorizontal: wp(92),
                            backgroundColor: "black",
                            marginTop: spV(48),
                            marginBottom: spV(28),
                            paddingVertical: hp(40),
                        }}
                    >
                        <View
                            style={{
                                marginRight: spH(25),
                            }}
                        >
                            {item?.[3] && <EditItem gender={gender} router={router} index={3} {...item?.[3]} />}
                        </View>
                        <View
                            style={{
                                marginRight: spH(25),
                            }}
                        >
                            {item?.[4] && <EditItem gender={gender} router={router} index={4} {...item?.[4]} />}
                        </View>
                        {item?.[5] && <EditItem gender={gender} router={router} index={5} {...item?.[5]} />}
                    </View>
                )}
                {item?.[6] && (
                    <View
                        style={{
                            flexDirection: "row",
                            width: "100%",
                            paddingHorizontal: wp(92),
                            marginTop: spV(48),
                            marginBottom: spV(28),
                            paddingVertical: hp(40),
                        }}
                    >
                        <View
                            style={{
                                marginRight: spH(25),
                            }}
                        >
                            {item?.[6] && <EditItem gender={gender} router={router} index={6} {...item?.[6]} />}
                        </View>
                        <View
                            style={{
                                marginRight: spH(25),
                            }}
                        >
                            {item?.[7] && <EditItem gender={gender} router={router} index={7} {...item?.[7]} />}
                        </View>
                        {item?.[8] && <EditItem gender={gender} router={router} index={8} {...item?.[8]} />}
                    </View>
                )}
            </View>
            <View>
                {item?.[9] && <EditItem gender={gender} router={router} index={9} {...item?.[9]} />}
                {item?.[10] && (
                    <View
                        style={{
                            flexDirection: "row",
                            width: "100%",
                            paddingHorizontal: wp(93.5),
                            marginTop: spV(48),
                            marginBottom: spV(28),
                        }}
                    >
                        <View
                            style={{
                                marginRight: spH(31),
                            }}
                        >
                            {item?.[10] && <EditItem gender={gender} router={router} index={10} {...item?.[10]} />}
                        </View>
                        {item?.[11] && <EditItem gender={gender} router={router} index={11} {...item?.[11]} />}
                    </View>
                )}
                {item?.[12] && (
                    <View
                        style={{
                            flexDirection: "row",
                            width: "100%",
                            paddingHorizontal: wp(92),
                            marginTop: spV(48),
                            marginBottom: spV(28),
                            paddingVertical: hp(40),
                        }}
                    >
                        <View
                            style={{
                                marginRight: spH(25),
                            }}
                        >
                            {item?.[12] && <EditItem gender={gender} router={router} index={12} {...item?.[12]} />}
                        </View>
                        <View
                            style={{
                                marginRight: spH(25),
                            }}
                        >
                            {item?.[13] && <EditItem gender={gender} router={router} index={13} {...item?.[13]} />}
                        </View>
                        {item?.[14] && <EditItem gender={gender} router={router} index={14} {...item?.[14]} />}
                    </View>
                )}
            </View>
            {item?.[15] && (
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        flexWrap: "wrap",
                        paddingHorizontal: spH(92),
                        paddingTop: spV(40),
                        backgroundColor: "black",
                    }}
                >
                    {item?.slice(15, 27)?.map((o, idx) => (
                        <View
                            style={{
                                marginBottom: spV(80),
                                marginRight: [2, 5, 8, 11].includes(idx) ? 0 : spH(20),
                            }}
                        >
                            {item?.[idx + 15] && (
                                <EditItem gender={gender} router={router} index={idx + 15} {...item?.[idx + 15]} />
                            )}
                        </View>
                    ))}
                </View>
            )}
        </View>
    );
};

export default ShoppablePageItem;

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    mainTitle: {
        alignSelf: "center",
        marginTop: spV(28),
        fontFamily: "LibreBodoni",
        fontSize: fp(28),
        fontWeight: "300",
        marginBottom: -spV(14),
    },
    listViewContainer: {
        // paddingHorizontal: wp(92),
        paddingTop: hp(28),
    },
    listViewContentContainer: {
        paddingHorizontal: spH(90),
    },
    subTitle: {
        fontFamily: "JosefinSans",
        fontWeight: "350",
        fontSize: fp(20),
        color: Colors.black,
        marginTop: 5,
        lineHeight: "140%",
        textAlign: "center",
    },
    button: {
        marginTop: 5,
    },
    buttonText: {
        fontFamily: "JosefinSans",
        fontSize: fp(20),
        color: "#000",
        textDecorationLine: "underline",
    },
    itemTitle: {
        fontFamily: "LibreBodoni",
        fontSize: fp(24),
        fontWeight: "200",
        textAlign: "center",
    },
    loadingContainer: {
        height: spV(300),
        justifyContent: "center",
        alignItems: "center",
    },
});
